import React from "react";
import Layout from "../PageLayout/LoginLayout";
import { useNavigate } from "react-router-dom";

export default function PasswordSuccess() {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex min-h-screen items-center justify-center px-4">
        {/* Added max-w-xl for wider container */}
        <div className="w-full max-w-xl mx-auto text-start">
          <h1 className="text-2xl font-semibold mb-2">Your password has been renewed</h1>
          <p className="text-gray-500 mb-8">
            Password reset process has been completed successfully.<br />
            You can now continue exploring the platform using your new password.
          </p>
          <button
            onClick={() => navigate("/login")}
            className="w-full bg-[#1E1E2F] text-white rounded-md py-3 text-base font-medium hover:bg-gray-800"
          >
            Login
          </button>
        </div>
      </div>
    </Layout>
  );
}
